
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import SingularityPanelHeader from "../../PanelHeader/SingularityPanelHeader.vue";
import { singularityStore } from "@/store/store";
import BrandColorPicker from "./BrandColorPicker.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { NamedColorPalette } from "@/types/singularity/brand";
import {
  generatePalette,
  inlineContainerStyle,
  randomPalette,
  saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings
} from "@/lib/singularity/brand/color";
import Icon from "@/components/UI/Icon.vue";
import clipboardCopy from "clipboard-copy";
import IconButton from "@/components/UI/IconButton.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";

@Component({
  components: {
    SingularityPanelHeader,
    IconButton,
    BrandColorPicker,
    TextInput,
    Icon,
    NiceButton,
    CopyButton
  }
})
export default class BrandPanelColorEdit extends Vue {
  get currentPalette() {
    return singularityStore.currentPalette
      ? singularityStore.currentPalette.palette
      : null;
  }

  get currentIndex() {
    return singularityStore.currentPalette
      ? singularityStore.currentPalette.index
      : null;
  }

  internalPalette: NamedColorPalette | null = this.currentPalette;

  style(color: string) {
    if (!this.currentPalette) {
      return {};
    }
    return inlineContainerStyle(color, this.currentPalette);
  }

  updateColor(color: string) {
    if (!this.internalPalette) {
      return;
    }

    const newPalette = generatePalette(color);

    this.internalPalette = {
      ...this.internalPalette,
      base: newPalette.base,
      scale: newPalette.scale,
      text: newPalette.text
    };

    this.updatePalette();
  }

  copyColor(color: string) {
    clipboardCopy(color);
  }

  updateLabel(label: string) {
    if (!this.internalPalette) {
      return;
    }
    this.internalPalette.label = label;
  }

  shufflePalette() {
    if (!this.internalPalette) {
      return;
    }

    const palette = randomPalette();

    this.internalPalette = {
      ...palette,
      primary: this.internalPalette.primary
    };

    this.updatePalette();
  }

  updatePalette() {
    if (!this.internalPalette) {
      return;
    }

    if (this.internalPalette.primary) {
      singularityStore.setPalette({
        type: "primary",
        palette: this.internalPalette
      });
    } else {
      singularityStore.updateSecondaryPalette({
        index: this.currentIndex ?? 0,
        palette: this.internalPalette
      });
    }

    saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings();
  }

  @Watch("currentPalette")
  onPaletteChange(newPalette: NamedColorPalette) {
    this.internalPalette = { ...newPalette };
  }
}
